
import { Utilities } from "../general/utilities";
import { ProductId } from "./NavigatorData";

export interface BaseConfiguration {
    InputFilenameA: string,
    InputFilenameB: string,
    InputFileA: File | null,
    InputFileB: File | null,
    ResultFilename: string,

}

export const InputFilenameAId = Utilities.nameof<BaseConfiguration>('InputFilenameA');
export const InputFilenameBId = Utilities.nameof<BaseConfiguration>('InputFilenameB');
export const InputFileA = Utilities.nameof<BaseConfiguration>('InputFileA');
export const InputFileB = Utilities.nameof<BaseConfiguration>('InputFileB');
export const ResultFilename = Utilities.nameof<BaseConfiguration>('ResultFilename');

export default interface FormDataType {
    [ProductId.ccS1000D]: BaseConfiguration,
    [ProductId.ccJATS]: BaseConfiguration,
    [ProductId.ccBITS]: BaseConfiguration,
    [ProductId.ccNISOSTS]: BaseConfiguration,
    [ProductId.ccXSLFO]: BaseConfiguration
}

export default class ConfigFormData {
    
    public static defaults: FormDataType = {
        [ProductId.ccS1000D]: {
            InputFilenameA: `deltaxml-s1000d-inputA.xml`,
            InputFilenameB: `deltaxml-s1000d-inputB.xml`,
            InputFileA: null,
            InputFileB: null,
            ResultFilename: "deltaxml-content-compare-s1000d-result.xml",
        },
        [ProductId.ccJATS]: {
            InputFilenameA: `deltaxml-jats-inputA.xml`,
            InputFilenameB: `deltaxml-jats-inputB.xml`,
            InputFileA: null,
            InputFileB: null,
            ResultFilename: "deltaxml-content-compare-jats-result.xml",
        },
        [ProductId.ccBITS]: {
            InputFilenameA: `deltaxml-bits-inputA.xml`,
            InputFilenameB: `deltaxml-bits-inputB.xml`,
            InputFileA: null,
            InputFileB: null,
            ResultFilename: "deltaxml-content-compare-bits-result.xml",
        },
        [ProductId.ccNISOSTS]: {
            InputFilenameA: `deltaxml-nisosts-inputA.xml`,
            InputFilenameB: `deltaxml-nisosts-inputB.xml`,
            InputFileA: null,
            InputFileB: null,
            ResultFilename: "deltaxml-content-compare-nisosts-result.xml",
        },
        [ProductId.ccXSLFO]: {
            InputFilenameA: `deltaxml-xslfo-inputA.xml`,
            InputFilenameB: `deltaxml-xslfo-inputB.xml`,
            InputFileA: null,
            InputFileB: null,
            ResultFilename: "deltaxml-content-compare-xslfo-result.xml",
        }
    }
    static ConfigFormData: any;
}